export default __webpack_public_path__ + "images/6D.0eb2717.png";